export class AffiliateTypeMasterMinDc {
    public AffiliateTypeId: number;
    public AffiliateTypeName: string;  
}

export enum AffiliateTypeId {
    Individual = 1,
    Business = 2,
    TeamLead = 3,
    Marketing = 4,
    Promoter = 5,
    Associate = 6
}

export enum RelationshipId {
    Prospect = 1,
    Partner = 2,
    Paused = 3,
    Cancelled = 4,
    Archieve = 5,
    Referrer = 6
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/models/affiliate/affiliate-type-master-min-dc.model.ts